import { RemoteCreateFieldAssessments } from 'data/usecases';
import { makeApiUrlFieldAssessments } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateFieldAssessments =
  (): RemoteCreateFieldAssessments => {
    return new RemoteCreateFieldAssessments(
      makeApiUrlFieldAssessments(),
      makeAxiosHttpClient(),
    );
  };
